import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';
import SubTitle from '../components/Text/SubTitle';

const styles = (theme) => ({
  body: {
    fontSize: '1.3em',
    lineHeight: 1.8,
    '& span': {
      // color: 'red',
      fontWeight: 'bold',
    },
  },

  importantDatesDiv: {
    // borderRadius: 0,
    color: '#fff',
    // boxShadow: 'none',
    padding: theme.spacing(4, 5),
  },
  importantDatesDate: {
    fontWeight: 'bold',
    fontSize: '1.6em',
  },
  importantDatesTitle: {
    fontSize: '1.1em',
  },

  stepsDiv: {
    display: 'flex',
  },
  stepItem: {
    width: '20%',
  },
  stepsNo: {
    fontSize: '1.2em',
    color: '#7d889a',
    '& span': {
      fontSize: '1.2em',
      fontWeight: 'bold',
    },
  },
  stepContent: {
    padding: theme.spacing(2, 4),
    color: '#fff',
    height: '130px',
  },

  topicTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '1.2em',
    marginBottom: '0.5em',
  },
  topicContents: {
    '& p': {
      paddingLeft: 8,
      textIndent: -8,
    },
  },

  orderedList: {
    '& li': { marginBottom: '.5rem', fontWeight: 500, fontSize: '1.2em', lineHeight: 1.8 },
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    color: '#555',
    '& th': { textAlign: 'center', fontWeight: 'bold' },
    '& td': {
      fontWeight: 500,
      '& p': {
        textIndent: '-0.65em',
        paddingLeft: '0.6em',
      },
    },
    // '&:nth-of-type(odd)': {
    //   '& th': {
    //     backgroundColor: '#cfdae6',
    //   },
    //   '& td': {
    //     backgroundColor: '#e6edf6',
    //   },
    // },
    // '&:nth-of-type(even)': {
    //   '& th': {
    //     backgroundColor: '#e9eff5',
    //   },
    //   '& td': {
    //     backgroundColor: '#f4f7fa',
    //   },
    // },
  },
}))(TableRow);

// const StyledTableCell = withStyles((theme) => ({
//   root: {
//     border: '1px solid',
//     borderColor: '#265c7a',
//     fontSize: 'medium',
//     fontWeight: 500,
//     padding: '8px 0',
//   },
// }))(TableCell);

const StyledTableCell = withStyles((theme) => ({
  root: {
    border: '2px solid',
    borderColor: '#fff',
    fontSize: '1.2em',
    fontWeight: 500,
    // padding: '8px 0',
    backgroundColor: '#e9eef1',
  },
}))(TableCell);

class RegistrationGuideEn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.stepNoRef = React.createRef();
    this.stepContentRef = React.createRef();
  }

  componentDidMount() {
    for (let i = 1; i <= 5; i++) {
      document.getElementById(`steps-content-${i}`).style.height = `${document.getElementById(`steps-content-1`).scrollHeight}px`;
    }
  }

  registrationProcess() {
    const { classes } = this.props;
    const STEPS = [
      {
        no: 1,
        color: '#7d889a',
        bgColor: 'rgba(125,136,154, 0.1)',
        title: 'STEP 01',
        content: 'Click Sign-up or Log in',
      },
      {
        no: 2,
        color: '#265c7a',
        bgColor: 'rgba(38, 92, 122, 0.1)',
        title: 'STEP 02',
        content: 'Fill out personal info and choose registration category',
      },
      {
        no: 3,
        color: '#0c7282',
        bgColor: 'rgba(12,114,130, 0.1)',
        title: 'STEP 03',
        content: 'Choose payment method and make payment',
      },
      {
        no: 4,
        color: '#7fb46d',
        bgColor: 'rgba(127,180,109, 0.1)',
        title: 'STEP 04',
        content: 'Check your email for payment confirmation',
      },
      {
        no: 5,
        color: '#d0d24d',
        bgColor: 'rgba(216,223,86, 0.1)',
        title: 'STEP 05',
        content: 'Complete',
      },
    ];

    return (
      <div className={classes.stepsDiv}>
        {STEPS.map((step, idx) => (
          <div key={`step-for-submission-${idx}`} className={classes.stepItem}>
            <div
              className={classes.stepsNo}
              style={{
                backgroundColor: step.bgColor,
                position: 'relative',
                padding: this.props.theme.spacing(2, 0),
                display: 'flex',
                alignItems: 'baseline',
              }}
              id={`steps-no-${idx + 1}`}
            >
              <p style={{ backgroundColor: step.color, width: '1em', height: '0.3em', position: 'absolute', bottom: '20%', left: 0 }} />
              <div style={{ marginLeft: 20 }}>
                Step <span style={{ color: step.color }}>0{idx + 1}</span>
              </div>
            </div>
            <div
              className={classes.stepContent}
              style={{ backgroundColor: step.color, height: 'auto !important', textAlign: 'center' }}
              id={`steps-content-${idx + 1}`}
            >
              <Typography style={{ fontSize: '1.2em', marginTop: '0.5em', fontWeight: 'bold' }}>{step.content}</Typography>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { classes, theme, parent } = this.props;
    return (
      <React.Fragment>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <SubTitle>Guideline</SubTitle>
            {/* <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => parent.history.push('/registration/submission')}
              style={{ width: '200px', padding: '0.5em 0', marginBottom: 10, textTransform: 'none' }}
            >
              Online Registration
            </Button> */}
          </div>
          <Grid container direction="row" alignItems="center" justifyContent={'space-between'}>
            <Grid>
              <Typography className={classes.body}>
                All participants are required to register through the PRS KOREA 2022 online registration system and advised to register in
                advance.&nbsp;
                <br />
                <b style={{ color: '#f00' }}>(By October 31 (Mon), 23:59(KST), 2022)</b>
                <br />
                <b style={{ color: '#f00' }}>* If you have not done PRS KOREA 2022 Sign-up yet, please use Sign-up first.</b>
              </Typography>
            </Grid>

            {/* <Grid container justifyContent="center" style={{ textAlign: 'center', marginTop: '1em' }}>
              <Button
                variant="contained"
                // color="primary"
                // disableElevation
                onClick={() => parent.history.push('/registration/submission')}
                style={{
                  borderRadius: '5px',
                  backgroundColor: this.props.theme.palette.primary.main,
                  color: '#fff',
                  fontSize: '1.4em',
                  padding: '1em 0',
                  textTransform: 'none',
                  width: '300px',
                  fontWeight: 'bold',
                }}
                // startIcon={<FaFileUpload size={30} />}
              >
                Online Registration
              </Button>
            </Grid> */}

            <Grid container style={{ paddingTop: 20 }}>
              <Grid container justifyContent="center">
                <Grid container justifyContent="center">
                  <Button
                    variant="contained"
                    // color="primary"
                    // disableElevation
                    onClick={() => parent.history.push('/choose')}
                    style={{
                      borderRadius: '5px',
                      backgroundColor: this.props.theme.palette.secondary.main,
                      color: '#fff',
                      fontSize: '1.4em',
                      fontWeight: 'bold',
                      padding: '1em 0',
                      textTransform: 'none',
                      width: '300px',
                      marginRight: 20,
                    }}
                    // startIcon={<FaFileUpload size={30} />}
                  >
                    Sign-up
                  </Button>{' '}
                  <Button
                    variant="contained"
                    // color="primary"
                    // disableElevation
                    onClick={() => parent.history.push('/registration/submission')}
                    style={{
                      borderRadius: '5px',
                      backgroundColor: this.props.theme.palette.primary.main,
                      color: '#fff',
                      fontSize: '1.4em',
                      fontWeight: 'bold',
                      padding: '1em 0',
                      textTransform: 'none',
                      width: '300px',
                      marginLeft: 20,
                    }}
                    // startIcon={<FaFileUpload size={30} />}
                  >
                    Online Registration
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid />
          </Grid>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Important Dates</SubTitle>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#7d889a', borderRadius: '5px' }}>
                <Typography className={classes.importantDatesTitle}>Deadline for Early-Bird Registration</Typography>
                <Typography className={classes.importantDatesDate}>September 16 (Fri), 2022</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#237a9d', borderRadius: '5px' }}>
                <Typography className={classes.importantDatesTitle}>Deadline for Presenter Registration</Typography>
                <Typography className={classes.importantDatesDate}>October 31 (Mon), 2022</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#164273', borderRadius: '5px' }}>
                <Typography className={classes.importantDatesTitle}>Regular Registration</Typography>
                <Typography className={classes.importantDatesDate}>October 31 (Mon), 2022</Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Registration Process</SubTitle>
          {this.registrationProcess()}
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Registration Fees</SubTitle>
          {/*<Typography style={{ fontWeight: 'bold', paddingBottom: 10 }}>Korean</Typography>*/}
          {/*<Table>*/}
          {/*  <TableHead>*/}
          {/*    <TableRow>*/}
          {/*      <TableCell*/}
          {/*        style={{ backgroundColor: '#41587e', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}*/}
          {/*      >*/}
          {/*        등록구분*/}
          {/*      </TableCell>*/}
          {/*      <TableCell*/}
          {/*        style={{ backgroundColor: '#41587e', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}*/}
          {/*      >*/}
          {/*        조기등록*/}
          {/*        <br />*/}
          {/*        (2021년 8월 31일까지)*/}
          {/*      </TableCell>*/}
          {/*      <TableCell*/}
          {/*        style={{ backgroundColor: '#41587e', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}*/}
          {/*      >*/}
          {/*        사전등록*/}
          {/*        <br />*/}
          {/*        (2021년 9월1일~10월 29일까지)*/}
          {/*      </TableCell>*/}
          {/*      <TableCell*/}
          {/*        style={{ backgroundColor: '#41587e', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}*/}
          {/*      >*/}
          {/*        현장등록*/}
          {/*        <br />*/}
          {/*        (2021년 11월 12일~14일)*/}
          {/*      </TableCell>*/}
          {/*    </TableRow>*/}
          {/*  </TableHead>*/}
          {/*  <TableBody>*/}
          {/*    <StyledTableRow>*/}
          {/*      <TableCell align="center">정회원</TableCell>*/}
          {/*      <TableCell align="center">KRW 200,000</TableCell>*/}
          {/*      <TableCell align="center">KRW 250,000</TableCell>*/}
          {/*      <TableCell align="center">KRW 300,000</TableCell>*/}
          {/*    </StyledTableRow>*/}
          {/*    <StyledTableRow>*/}
          {/*      <TableCell align="center">군의관,공보의</TableCell>*/}
          {/*      <TableCell align="center">KRW 150,000</TableCell>*/}
          {/*      <TableCell align="center">KRW 200,000</TableCell>*/}
          {/*      <TableCell align="center">KRW 250,000</TableCell>*/}
          {/*    </StyledTableRow>*/}
          {/*    <StyledTableRow>*/}
          {/*      <TableCell align="center">*/}
          {/*        전공의*/}
          {/*        <br />*/}
          {/*        (수련병원 근무 외국인의사 동일)*/}
          {/*      </TableCell>*/}
          {/*      <TableCell align="center">KRW 120,000</TableCell>*/}
          {/*      <TableCell align="center">KRW 150,000</TableCell>*/}
          {/*      <TableCell align="center">KRW 200,000</TableCell>*/}
          {/*    </StyledTableRow>*/}
          {/*  </TableBody>*/}
          {/*</Table>*/}
          {/*<div>*/}
          {/*  <div style={{ height: '50px' }} />*/}
          {/*</div>*/}
          {/* <Typography style={{ fontWeight: 'bold', paddingBottom: 10 }}>International</Typography> */}
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell
                  style={{
                    borderRight: '1px solid #fff',
                    backgroundColor: '#237a9d',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  Category
                </StyledTableCell>
                <StyledTableCell
                  style={{
                    borderRight: '1px solid #fff',
                    backgroundColor: '#237a9d',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  Early-Bird Registration
                  <br />
                  (Until September 16, 23:59(KST))
                </StyledTableCell>
                <StyledTableCell
                  style={{
                    borderRight: '1px solid #fff',
                    backgroundColor: '#237a9d',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  Regular Registration
                  <br />
                  (From September 17 to October 31, 23:59(KST))
                </StyledTableCell>
                <StyledTableCell
                  style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                >
                  On-site Registration
                  <br />
                  (From November 11~13, 2022)
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="center">KSPRS International Member</StyledTableCell>
                <StyledTableCell align="center">USD 300</StyledTableCell>
                <StyledTableCell align="center">USD 400</StyledTableCell>
                <StyledTableCell align="center">USD 500</StyledTableCell>
              </StyledTableRow>

              <StyledTableRow>
                <StyledTableCell align="center">
                  Physicians of Guest Nations Society
                  <br />
                  (UAE)
                </StyledTableCell>
                <StyledTableCell align="center">USD 300</StyledTableCell>
                <StyledTableCell align="center">USD 400</StyledTableCell>
                <StyledTableCell align="center">USD 500</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">
                  KSPRS Global Partners-MOU Country <br />
                  (ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS){' '}
                </StyledTableCell>
                <StyledTableCell align="center">USD 300</StyledTableCell>
                <StyledTableCell align="center">USD 450</StyledTableCell>
                <StyledTableCell align="center">USD 550</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">Guest Physicians</StyledTableCell>
                <StyledTableCell align="center">USD 400</StyledTableCell>
                <StyledTableCell align="center">USD 500</StyledTableCell>
                <StyledTableCell align="center">USD 600</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">International Trainee</StyledTableCell>
                <StyledTableCell align="center">USD 150</StyledTableCell>
                <StyledTableCell align="center">USD 170</StyledTableCell>
                <StyledTableCell align="center">USD 200</StyledTableCell>
              </StyledTableRow>
              {/* <StyledTableRow>
                <TableCell align="center">Non-Member Physicians</TableCell>
                <TableCell align="center">USD 400</TableCell>
                <TableCell align="center">USD 450</TableCell>
                <TableCell align="center">USD 500</TableCell>
              </StyledTableRow> */}
            </TableBody>
          </Table>
        </div>
        <div>
          <div style={{ height: '20px' }} />
        </div>
        <div>
          <SubTitle>Payment Method</SubTitle>
          <span className={classes.orderedList} style={{ fontSize: '1.2em', lineHeight: 1.8 }}>
            You can check the payment status of your registration on 'My Page.'
            <br />
            Registration Fees can be paid using one of the following options:
          </span>
          <div>
            <div style={{ height: '20px' }} />
          </div>
          <Typography style={{ fontWeight: 'bold' }}>1) Credit Card</Typography>
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList}>
              <li>Payment by credit card is available only through the on-line registration system.</li>
              <li>All credit card service charges are to be paid by registrants.</li>
              <li>The actual debit amount is subject to change according to the exchange rate.</li>
              <li>
                The merchant name on your credit card statement will be{' '}
                <span style={{ color: 'red' }}>'Eximbay' (Non-Korean) or ‘Easy Pay’ (Korean).</span>
              </li>
            </ul>
          </div>
          <Typography style={{ fontWeight: 'bold' }}>2) Bank Wire Transfer</Typography>
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList}>
              <li>Bank transfer should be made to the account below. All bank charges for remittance must be paid by registrants.</li>
              <li>Please note that the transfer must be made under the registrant’s name and must be stated on the receipt.</li>
              <li>
                Please send an e-mail to the Secretariat(
                <a href={'mailto:secretariat.kprs@innon.co.kr'} style={{ fontWeight: 'bold', color: 'blue' }}>
                  secretariat.kprs@innon.co.kr
                </a>
                . ) with a copy of the transfer record.
              </li>
              <li>If your payment is completed, the Payment Status will change from ‘Waiting’ to ‘Complete’.</li>
              <li>If you would like to change your payment method, please contact the Secretariat.</li>
              <li style={{ lineHeight: 2 }}>
                A payment confirmation letter will be sent within 3 weeks after payment is received.
                <br /> If you do not receive the confirmation letter, please contact the secretariat at&nbsp;
                <a href={'mailto:secretariat.kprs@innon.co.kr'} style={{ fontWeight: 'bold', color: 'blue' }}>
                  secretariat.kprs@innon.co.kr
                </a>
                .
              </li>
            </ul>
          </div>
          <div>
            <div style={{ height: '20px' }} />
          </div>
          {/*<Typography style={{ fontWeight: 'bold' }}>For Korean</Typography>*/}
          {/*<Table>*/}
          {/*  <TableBody>*/}
          {/*    <StyledTableRow>*/}
          {/*      <TableCell align="center" component={'th'}>*/}
          {/*        Bank Name*/}
          {/*      </TableCell>*/}
          {/*      <TableCell align="center">KEB Hana Bank</TableCell>*/}
          {/*    </StyledTableRow>*/}
          {/*    <StyledTableRow>*/}
          {/*      <TableCell align="center" component={'th'}>*/}
          {/*        Account Number*/}
          {/*      </TableCell>*/}
          {/*      <TableCell align="center">224-910038-67404</TableCell>*/}
          {/*    </StyledTableRow>*/}
          {/*    <StyledTableRow>*/}
          {/*      <TableCell align="center" component={'th'}>*/}
          {/*        Account Beneficiary*/}
          {/*      </TableCell>*/}
          {/*      <TableCell align="center">Korean Society of Plastic and Reconstructive Surgeons (KSPRS)</TableCell>*/}
          {/*    </StyledTableRow>*/}
          {/*  </TableBody>*/}
          {/*</Table>*/}
          <div>
            <div style={{ height: '20px' }} />
          </div>
          {/*<Typography style={{ fontWeight: 'bold', paddingBottom: 10 }}>For International</Typography>*/}
          <Table>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Bank Name
                </StyledTableCell>
                <StyledTableCell align="center">Hana Bank</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Beneficiary Account
                </StyledTableCell>
                <StyledTableCell align="center">Korean Society of Plastic and Reconstructive Surgeons (KSPRS)</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Account Number
                </StyledTableCell>
                <StyledTableCell align="center">224-910007-31232</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Swift Code
                </StyledTableCell>
                <StyledTableCell align="center">KOEXKRSE or KOEXKRSEXXX</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Branch Name
                </StyledTableCell>
                <StyledTableCell align="center">Seochonam Banking Center</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Bank Address
                </StyledTableCell>
                <StyledTableCell align="center">06733, Seoun-ro 3, Seocho-gu, Seoul</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  Contact Information
                </StyledTableCell>
                <StyledTableCell align="center">+82-2-3472-1111​</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
          <div>
            <div style={{ height: '50px' }} />
          </div>
          <SubTitle>Registration Confirmation</SubTitle>
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList}>
              <li>
                Registration confirmation will be sent to you via e-mail right after the completion of online registration (Credit Card).
              </li>
              <li>
                Registration confirmation will be sent to you via e-mail within three weeks upon making the full payment (Bank Wire
                Transfer).
              </li>
              <li>Registration without complete payment will not be honored until the full payment is received.</li>
            </ul>
          </div>
          <div>
            <div style={{ height: '50px' }} />
          </div>
          <SubTitle>Cancellation and Refund Policy</SubTitle>
          {/*<div style={{ textAlign: 'center', marginTop: '1em' }}>*/}
          {/*  <Button*/}
          {/*    variant="contained"*/}
          {/*    color="primary"*/}
          {/*    disableElevation*/}
          {/*    onClick={() => this.props.cancellationFormDownload()}*/}
          {/*    style={{ width: '200px', padding: '0.5em 0' }}*/}
          {/*  >*/}
          {/*    Cancellation Form Download*/}
          {/*  </Button>*/}
          {/*</div>*/}
          <div style={{ color: '#555' }}>
            <ul className={classes.orderedList}>
              <li>Any cancellation of registration should be notified in writing to the secretariat by e-mail.</li>
              <li>All refunds will be processed after the conference.</li>
              <li>Please refer to the following deadlines for cancellation.</li>
            </ul>
          </div>
          <Table>
            <TableBody>
              <StyledTableRow>
                <TableCell
                  align="center"
                  component={'th'}
                  width="50%"
                  style={{
                    backgroundColor: '#237a9d',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: 'large',
                    textAlign: 'center',
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  align="center"
                  component={'th'}
                  style={{
                    backgroundColor: '#237a9d',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: 'large',
                    textAlign: 'center',
                  }}
                >
                  Amount to be refunded
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">Until October 31 (Fri), 2022</StyledTableCell>
                <StyledTableCell align="center">Full Refund</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">From November 1 (Tue), 2022</StyledTableCell>
                <StyledTableCell align="center">No Refund</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(RegistrationGuideEn);
